import { getApiLink } from "./getApiLink";

let getDataByPostalCode = async( postal ) => {
    let data = 'postal='+ postal; 
    
    const rawResponse = await fetch(`${ getApiLink() }/getPostalCode.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: data
    });

    const content = await rawResponse.json();
    return content;

}

export default getDataByPostalCode;